export const CASHIER_SUMMARY_REPORT_GO_BUTTON_API = 'CASHIER_SUMMARY_REPORT_GO_BUTTON_API'
export const CASHIER_SUMMARY_REPORT_GO_BUTTON_API_SUCCESS = 'CASHIER_SUMMARY_REPORT_GO_BUTTON_API_SUCCESS'


export const CASHIER_SUMMARY_REPORT_API_ERROR_ACTION = 'CASHIER_SUMMARY_REPORT_API_ERROR_ACTION'